<div class="h-100 d-flex flex-column container-404">
    <div>
        <h1 style="font-size: 35vh">404</h1>
        <h2 style="font-size: 8vh">Page Not Found</h2>
    </div>
</div>